/**
 * 集成app和微信分享组件
 * 使用方法wxShare.init({title:"1",description:"2",url:"3",shareIcon:"url",scene:[1,2],callback:""}),scene为app分享参数：1:微信好友,2:微信朋友圈,3:qzone,4:qq,5微博:6:通讯录邀请,7通讯录分享；
 */

/**
 * 初始化微信分享配置
 * @param shareParams
 * @param jsSdkPackage
 */
function initWeixinShare(shareParams, jsSdkPackage) {
  window.wx.config({
    // debug: true,
    appId: jsSdkPackage['appId'],
    timestamp: jsSdkPackage['timestamp'],
    nonceStr: jsSdkPackage['nonceStr'],
    signature: jsSdkPackage['signature'],
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'hideMenuItems',
      'hideAllNonBaseMenuItem'],
  });

  window.wx.ready(function() {
    console.log('wx ready');
    if (String(shareParams['isValid']) === '0') {
      console.log('share config is offline');
      window.wx.hideAllNonBaseMenuItem();
      return;
    }
    setWeixinShare(shareParams);
  });
  window.wx.error(function(res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，
    // 具体错误信息可以打开config的debug模式查看，
    // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    console.log('wx error:' + JSON.stringify(res));
  });
}

/**
 * 获取微信的分享参数
 * @param shareParams
 */
function getSdkPackage(shareParams) {
  const url = 'https://www.xiaoying.com/common/getWeixinJsSdkPackage';
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: url,
    data: {},
    success: function(response) {
      if (response && response.data) {
        initWeixinShare(shareParams, response['data']);
      } else {
        console.log('获取微信SDK PACKAGE出错');
      }
    },
  });
}

/**
 * 设置微信分享内容
 */
function setWeixinShare(shareParams) {
  'use strict';
  var menuList = [];//需要隐藏的传播按钮
  //配置 scene
  var scene = shareParams.scene ? shareParams.scene : [];
  if (scene.indexOf(1) === -1) {
    menuList.push('menuItem:share:appMessage');
  }
  if (scene.indexOf(2) === -1) {
    menuList.push('menuItem:share:timeline');
  }
  if (scene.indexOf(3) === -1) {
    menuList.push('menuItem:share:QZone');
  }
  if (scene.indexOf(4) === -1) {
    menuList.push('menuItem:share:qq');
  }
  if (scene.indexOf(5) === -1) {
    menuList.push('menuItem:share:weiboApp');
  }
  //分享到朋友圈
  window.wx.onMenuShareTimeline({
    title: shareParams['title'],      // 分享标题
    link: shareParams['url'],         // 分享链接
    imgUrl: shareParams['shareIcon'], // 分享图标
    success: function() {
      console.log({ret: 0, src: 'timeline'});
    },
    cancel: function() {
      console.log({ret: 2, src: 'timeline'});
    },
  });
  //分享到微信好友
  window.wx.onMenuShareAppMessage({
    title: shareParams['title'],
    desc: shareParams['description'],
    link: shareParams['url'], // 分享链接
    imgUrl: shareParams['shareIcon'],
    type: 'link',
    success: function() {
      console.log({ret: 0, src: 'appMessage'});
    },
    cancel: function() {
      console.log({ret: 0, src: 'appMessage'});
    },
  });
  //分享到QQ
  window.wx.onMenuShareQQ({
    title: shareParams['title'],
    desc: shareParams['description'],
    link: shareParams['url'], // 分享链接
    imgUrl: shareParams['shareIcon'],
    type: 'link',
    success: function() {
      console.log({ret: 0, src: 'appMessage'});
    },
    cancel: function() {
      console.log({ret: 2, src: 'appMessage'});
    },
  });
  //分享到微博
  window.wx.onMenuShareWeibo({
    title: shareParams['title'],
    link: shareParams['url'],// 分享链接
    imgUrl: shareParams['shareIcon'],
    success: function() {
      console.log({ret: 0, src: 'weibo'});
    },
    cancel: function() {
      console.log({ret: 2, src: 'weibo'});
    },
  });
  //分享到Qzone
  window.wx.onMenuShareQZone({
    title: shareParams['title'],
    desc: shareParams['description'],
    link: shareParams['url'], // 分享链接
    imgUrl: shareParams['shareIcon'],
    success: function() {
      console.log({ret: 0, src: 'qZone'});
    },
    cancel: function() {
      console.log({ret: 2, src: 'qZone'});
    },
  });
  if (menuList.length) {
    window.wx.hideMenuItems({menuList: menuList});
  }
}

/**
 * 初始化微信
 * @param shareParams
 */
function init(shareParams) {
  // 非微信客户端不进行调用
  if (!/MicroMessenger/.test(navigator.userAgent)) {
    console.log('分享仅能在微信环境中进行');
    return;
  }

  if (!shareParams) {
    console.log('微信分享参数设置不正确');
    return;
  }
  //过滤html转义字符
  shareParams['title'] = $('<div/>').html(shareParams['title']).text();
  //过滤html转义字符
  shareParams['description'] = $('<div/>').html(shareParams['description']).text();
  return getSdkPackage(shareParams);
}

export default {init};



// WEBPACK FOOTER //
// ./src/component/common/wxShare_v3.js